import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";
import NexusService from "./NexusService";
import FeatureFlagService from "./FeatureFlagService";

export default class ClientDocumentsService extends AbstractService {
	static endpoint = ENDPOINTS.clientDocuments;

	static clientDocumentsApi = NexusService.clientDocumentsApi;

	static clientDocumentsFeature = "use_api_core_endpoints_client_documents";

	static uploadClientDocument(id, fileData) {
		if (FeatureFlagService.isEnabled(this.clientDocumentsFeature)) {
			const request = {
				clientId: id,
				file: fileData,
			};
			return this.clientDocumentsApi.createClientDocument(request)
				.then((response) => ({ data: response }));
		}

		const data = new FormData();
		data.append("file", fileData);

		return this.post({
			endpoint: `${this.endpoint}?clientId=${id}`,
			queryParams: { fileName: fileData.name },
			data,
		});
	}

	static getClientDocument(id) {
		if (FeatureFlagService.isEnabled(this.clientDocumentsFeature)) {
			const request = {
				clientId: id,
			};
			return this.clientDocumentsApi.getClientDocuments(request)
				.then((response) => ({ data: response }));
		}
		return this.get({
			endpoint: `${this.endpoint}?clientId=${id}`,
		});
	}

	static deleteClientDocument(clientId, documentId) {
		if (FeatureFlagService.isEnabled(this.clientDocumentsFeature)) {
			const request = {
				clientId,
				documentId,
			};
			return this.clientDocumentsApi.deleteClientDocument(request)
				.then((response) => ({ data: response }));
		}
		return this.del({
			endpoint: `${this.endpoint}?clientId=${clientId}&documentId=${documentId}`,
		});
	}

}
